import { Component, ErrorInfo, ReactNode } from "react";
import { logger } from "./LoggerFactory";

interface Props {
  children: ReactNode;
  // Отсутствует, когда вызывающему хватает стандартного экрана ошибки: тогда
  // граница рисует свой собственный текст вместо переданного узла.
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    logger.error(
      { err: error, component: "ErrorBoundary", componentStack: info.componentStack ?? "" },
      "Unhandled React error",
    );
  }

  public render(): ReactNode {
    let renderOutcome: ReactNode;
    if (this.state.hasError) {
      renderOutcome = this.props.fallback ?? <div>Something went wrong.</div>;
    } else {
      renderOutcome = this.props.children;
    }
    return renderOutcome;
  }
}
